pageId = 'feishu-signups-new'
page = '#' + pageId

$ ->
  $page = $(page)
  $feishuSignupForm = $page.find '.feishu-signup-form'
  if $feishuSignupForm.length > 0
    tower.initMobileVerification $feishuSignupForm

